import { IChangeSimEsimOrchestrator } from "@nju/data-access-portal-orchestrator";
import { ISimCard } from "@nju/data-access-portal-product";
import { IEsimQRCode } from "@nju/data-access-portal-sim-card";

interface IGetChangeSimEsimBannerConditionProps {
  simId: string | undefined;
  subState: IEsimQRCode["subState"] | undefined;
  simNumber: string | undefined;
  changeSimEsimOrchestrator: IChangeSimEsimOrchestrator | undefined;
  simCardProduct: ISimCard | undefined;
}

export function getChangeSimEsimBannerCondition({
  simId,
  subState,
  simNumber,
  changeSimEsimOrchestrator,
  simCardProduct,
}: IGetChangeSimEsimBannerConditionProps) {
  const isEsim = changeSimEsimOrchestrator?.deliveryMethodId === "ESIM";
  const isEsimProducts = simCardProduct?.characteristic?.simType === "ESIM";
  const isSim = changeSimEsimOrchestrator?.deliveryMethodId === "COURIER";
  const orderSimNumber = changeSimEsimOrchestrator?.orderSimNumber;
  const isSubmitted =
    changeSimEsimOrchestrator?.state &&
    [
      "ORDER_COMMITTED",
      "ORDER_FULFILLMENT",
      "ORDER_FINISHING",
      "COMPLETED",
    ].includes(changeSimEsimOrchestrator.state);

  const shippingStatusWaitingForActivate =
    changeSimEsimOrchestrator?.shippingStatus &&
    [
      "PACK_CHAN",
      "DELV_PROGR_CHAN",
      "DELV_ZPO_CHAN",
      "DELV_CHAN",
      "RET_PROGR_CHAN",
    ].includes(changeSimEsimOrchestrator.shippingStatus);

  const shippingStatusWaitingForCancel =
    changeSimEsimOrchestrator?.shippingStatus &&
    ["RET_CHAN", "CANC_CHAN"].includes(
      changeSimEsimOrchestrator.shippingStatus,
    );

  if (
    isEsim &&
    changeSimEsimOrchestrator?.state === "COMPLETED" &&
    simId &&
    subState === "Downloaded"
  ) {
    return "cardEsimChangedCompleted";
  }

  if (
    isEsim &&
    isSubmitted &&
    simId !== orderSimNumber &&
    subState === "Downloaded"
  ) {
    return "cardChangedInProgress";
  }

  if (
    (isEsim && isSubmitted) ||
    (!changeSimEsimOrchestrator &&
      isEsimProducts &&
      simNumber &&
      subState === "Released")
  ) {
    return "completeReplacementQRCode";
  }

  if (
    isEsim &&
    isSubmitted &&
    simId !== orderSimNumber &&
    subState === "Downloaded"
  ) {
    return "cardChangedInProgress";
  }

  if (isSim && changeSimEsimOrchestrator?.state === "COMPLETED" && simId) {
    return "cardSimChangedCompleted";
  }

  if (
    isSim &&
    changeSimEsimOrchestrator?.state === "SIM" &&
    shippingStatusWaitingForActivate
  ) {
    return "completeReplacementAndActivatedCard";
  }

  if (
    isSim &&
    !orderSimNumber &&
    ["ORDER_COMMITTED", "ORDER_FULFILLMENT"].includes(
      changeSimEsimOrchestrator.state,
    )
  ) {
    return "deliveryInProgress";
  }

  if (isSim && isSubmitted && simId !== orderSimNumber) {
    return "cardChangedInProgress";
  }

  if (
    changeSimEsimOrchestrator?.state === "ORDER_PENDING_CANCELLATION" ||
    shippingStatusWaitingForCancel
  ) {
    return "orderPendingCancellation";
  }

  return;
}
